import api from './api';

class ModuleService {
  getModule() {
    return api.get('/merchant/get-module');
  }
}

export default new ModuleService();
